import { Link } from "react-router-dom";
import { Package, AlertTriangle } from "lucide-react";
import { PathTrail } from "@/components/PathTrail";
import { fileUrl } from "@/lib/api";
import { useI18n } from "@/i18n/I18n";

export const ItemThumb = ({ item, className = "w-14 h-14" }) => (
  <div className={`${className} shrink-0 rounded-md bg-slate-100 border border-slate-200 overflow-hidden flex items-center justify-center`}>
    {item.photo_path ? <img src={fileUrl(item.photo_path)} alt={item.name} className="w-full h-full object-cover" loading="lazy" />
      : <Package className="w-5 h-5 text-slate-400" />}
  </div>
);

export const isLow = (it) => it.min_quantity != null && it.quantity < it.min_quantity;

export const LowBadge = ({ testId }) => {
  const { t } = useI18n();
  return <span data-testid={testId} className="inline-flex items-center gap-1 rounded-full bg-red-50 border border-red-200 px-2 py-0.5 text-[10px] font-semibold text-red-700"><AlertTriangle className="w-3 h-3" />{t("stock.low")}</span>;
};

export const ItemCard = ({ item, catLabel }) => {
  const { t, fmtNum } = useI18n();
  return (
    <Link to={`/items/${item.id}`} data-testid={`item-card-${item.id}`}
      className="flex gap-3 rounded-xl border border-slate-200 bg-white p-3 transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-md active:scale-[0.99]">
      <ItemThumb item={item} />
      <div className="min-w-0 flex-1 space-y-1.5">
        <div className="flex items-start justify-between gap-2">
          <p className="font-semibold text-slate-900 truncate">{item.name}</p>
          <span className="flex items-center gap-1.5 shrink-0">
            {isLow(item) && <LowBadge testId={`low-badge-${item.id}`} />}
            <span className="font-mono text-xs text-slate-500">×{fmtNum(item.quantity)}</span>
          </span>
        </div>
        {catLabel && <p className="text-xs text-slate-500">{catLabel}</p>}
        <PathTrail path={item.path} linkable={false} emptyLabel={t("common.noLocation")} testId={`item-card-path-${item.id}`} />
      </div>
    </Link>
  );
};
